import camelcaseKeysDeep from 'camelcase-keys-deep'
import { ModuleNames } from '@/store/module-names'
import { PatientWithExerciseSummarysState, FlatPatientExerciseSummary } from './types'
import { getters } from './getters'
import { ActionNames, MutationNames } from './keys'

import { getPatientWithExerciseSummarysQuery } from '@/jsonapi/PatientWithExerciseSummary'

const state: PatientWithExerciseSummarysState = {
  patientWithExerciseSummarys: [],
}

const mutations = {
  [MutationNames.updatePatientWithExerciseSummarys](state, payload): void {
    state.patientWithExerciseSummarys = payload
  },
}

const actions = {
  async [ActionNames.getPatientWithExerciseSummarys]({ commit }): Promise<void> {
    const results = camelcaseKeysDeep(await getPatientWithExerciseSummarysQuery())
    commit(MutationNames.updatePatientWithExerciseSummarys, results)
  },
}

export default {
  name: ModuleNames.patientWithExerciseSummarys,
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
